export default "__VITE_ASSET__PjJX1KCp__"